import { render, staticRenderFns } from "./ShipGraphCombat.vue?vue&type=template&id=2601dc1c&scoped=true&"
import script from "./ShipGraphCombat.vue?vue&type=script&lang=js&"
export * from "./ShipGraphCombat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601dc1c",
  null
  
)

export default component.exports